import { render } from "./App.vue?vue&type=template&id=383d5954"
const script = {}

import "./App.vue?vue&type=style&index=0&id=383d5954&lang=css"

import exportComponent from "C:\\_Development\\JavaScript\\Vue\\flightlog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__